import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M23.59,14.47l-6.13-.78V8.53a3.46,3.46,0,1,0-6.91,0V19.25c-1-.45-1.79-.82-1.94-.88a3.45,3.45,0,0,0-3.92,1.19A3.39,3.39,0,0,0,4,22.12,3.45,3.45,0,0,0,5.38,24.4l6.55,4.91A3.46,3.46,0,0,0,14,30h9.57a2.64,2.64,0,0,0,2.62-2.31l1.06-8.45A4.3,4.3,0,0,0,23.59,14.47Z"/><path d="M8.6,12A.9.9,0,0,0,9,11.92a1,1,0,0,0,.54-1.3,4.79,4.79,0,1,1,8.85,0,1,1,0,1,0,1.84.76,6.73,6.73,0,0,0,.52-2.59A6.79,6.79,0,1,0,7.67,11.38,1,1,0,0,0,8.6,12Z"/>';
export var PressSVG = function PressSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
PressSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PressSVG);